/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateSSOImageLangViewModel } from "../types/UpdateSSOImageLangViewModel.ts";
import { eViewPortSchema } from "./eViewPortSchema.ts";

export const updateSSOImageLangViewModelSchema = z.object({
  id: z
    .number()
    .int()
    .describe(
      "ID da variação de idioma da imagem SSO a ser atualizada. Obrigatório.",
    ),
  cultureInfo: z
    .string()
    .min(1)
    .describe(
      "Código de cultura do idioma da variação (ex: pt-BR, en-US). Obrigatório.",
    ),
  file: z
    .instanceof(File)
    .describe(
      "Arquivo de imagem a ser enviado para esta variação de idioma/viewport. Obrigatório. Enviado como multipart/form-data.",
    ),
  viewPort: z
    .lazy(() => eViewPortSchema)
    .describe("1 = Desktop | 2 = Mobile | "),
}) as unknown as ToZod<UpdateSSOImageLangViewModel>;
